import { actionsInterpreter } from "../contentScript/actionsInterpreter";
import { isPatternInHtml } from "../contentScript/isPatternInHtml";
import { ActionsWithRules } from "../contentScript/RuleAction";
import {
  ActionsReport,
  ActionReportType,
  ActionReportItem,
} from "../contentScript/sendActionsReport";
import { logInfo } from "./log";

export interface CookieManagementPlatformRules {
  type: string;
  regexes: Array<string>;
  rules: Array<ActionsWithRules>;
}

export const searchForCookieManagementPlatforms = async (
  searchRules: Array<CookieManagementPlatformRules>
): Promise<ActionsReport> => {
  const startTime = new Date().valueOf();
  const documentHtml = document.documentElement.innerHTML;
  const allActions: Array<ActionReportItem> = [];
  const errors: Array<string> = [];

  for (const rule of searchRules) {
    // Check if any of the regexes match
    let matchFound = false;
    for (const pattern of rule.regexes) {
      if (isPatternInHtml(pattern, documentHtml)) {
        matchFound = true;
        break;
      }
    }

    if (matchFound) {
      // Process each rule with its actions
      for (const actionRule of rule.rules) {
        logInfo("Executing actions: ", actionRule.actions);
        const reportItems = await actionsInterpreter(actionRule.actions);

        // Add these actions to our consolidated list
        if (reportItems && reportItems.length > 0) {
          allActions.push(...reportItems);
        }

        logInfo("Actions executed for rule in cookie management platforms: ", {
          actions: reportItems,
          errors: [],
          processingTime: 0,
          type: ActionReportType.COOKIE_MANAGEMENT_PLATFORM,
          url: window.location.href,
        });

        // Check if any action was successful and matched a platform
        const anyElementClicked = reportItems.some(
          (item) => item.clicked === true
        );
        if (anyElementClicked) {
          // We found and interacted with a platform, no need to try others
          break;
        }
      }
    }
  }

  logInfo("Actions executed for cookie management platforms: ", allActions);

  return {
    actions: allActions, // Use the consolidated list
    errors: errors,
    processingTime: new Date().valueOf() - startTime,
    type: ActionReportType.COOKIE_MANAGEMENT_PLATFORM,
    url: window.location.href,
  };
};
